import * as React from "react";
import { Col, Container, Row, Image } from 'react-bootstrap'
import LazyLoad from 'react-lazy-load'

import FactsAndFiguresIcon1 from '../images/facts-and-figures-icon-1.svg'
import FactsAndFiguresIcon2 from '../images/facts-and-figures-icon-2.svg'
import FactsAndFiguresIcon3 from '../images/facts-and-figures-icon-3.svg'
import FactsAndFiguresIcon4 from '../images/facts-and-figures-icon-4.svg'

const ContactFormNew = React.lazy(() => import("../components/contact-form-new"));

const RequestQuote = ({
  title = "Contact Us<br><span class='text-primary'>for project discussion</span>",
  description = 'Once you fill out this form, our sales representatives will contact you within 24 hours.'
}) => {

  return (
    <>
      <section
        className='section footer-form-section '
        id='footer-contact'
      >
        <Container className='py-5'>
          {/* <div className="section-title mb-5 pb-1">
              <h2 className="heading mb-4" dangerouslySetInnerHTML={{ __html: title }} />
              <p className="lead max-width-950">{description}</p>
          </div> */}
          <Row>
            <Col lg={6}>
              <div className='0p-4 0p-lg-5'>
                <div className='section-title mb-5'>
                  <h2
                    className='heading text-white mb-4'
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                  <p className='text-white-75 lead'>{description}</p>

                  {/* <h3 className="heading text-white mb-3">Let’s create your incredible digital product together</h3>
                                        <p className="text-white-75">Don’t hesitate to share your valuable idea. Your personal information remains intact with us.</p> */}
                </div>
                <Row xs={2} className='g-5'>
                  <Col className='contact-us-line-y'>
                    <div className='d-flex flex-column'>
                      <LazyLoad offset={150}>
                        <i className='d-flex align-items-center icon-size-60 mb-3'>
                          <Image
                            loading='lazy'
                            className='lazyload'
                            src={FactsAndFiguresIcon1}
                            width={52}
                            height={49}
                            alt='FactsAndFiguresIcon1'
                          />
                        </i>
                      </LazyLoad>
                      <div className='flex-fill'>
                        <h3 className='h4 text-white font-size-24 mb-1'>
                          14+
                        </h3>
                        <p className='text-white-75 mb-0'>
                          Years of Experience
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className='d-flex flex-column'>
                      <LazyLoad offset={150}>
                        <i className='d-flex align-items-center icon-size-60 mb-3'>
                          <Image
                            loading='lazy'
                            className='lazyload'
                            src={FactsAndFiguresIcon2}
                            width={50}
                            height={50}
                            alt='FactsAndFiguresIcon2'
                          />
                        </i>
                      </LazyLoad>
                      <div className='flex-fill'>
                        <h3 className='h4 text-white font-size-24 mb-1'>
                          180+
                        </h3>
                        <p className='text-white-75 mb-0'>
                          In-House Talent
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className='contact-us-line-x contact-us-line-y'>
                    <div className='d-flex flex-column'>
                      <LazyLoad offset={150}>
                        <i className='d-flex align-items-center icon-size-60 mb-3'>
                          <Image
                            loading='lazy'
                            className='lazyload'
                            src={FactsAndFiguresIcon3}
                            width={50}
                            height={50}
                            alt='FactsAndFiguresIcon3'
                          />
                        </i>
                      </LazyLoad>
                      <div className='flex-fill'>
                        <h3 className='h4 text-white font-size-24 mb-1'>
                          750+
                        </h3>
                        <p className='text-white-75 mb-0'>
                          Project Delivered
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className='contact-us-line-x'>
                    <div className='d-flex flex-column'>
                      <LazyLoad offset={150}>
                        <i className='d-flex align-items-center icon-size-60 mb-3'>
                          <Image
                            loading='lazy'
                            className='lazyload'
                            src={FactsAndFiguresIcon4}
                            width={50}
                            height={50}
                            alt='FactsAndFiguresIcon4'
                          />
                        </i>
                      </LazyLoad>
                      <div className='flex-fill'>
                        <h3 className='h4 text-white font-size-24 mb-1'>
                          92%
                        </h3>
                        <p className='text-white-75 mb-0'>
                          Client satisfaction rate
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={6} className='mt-4 mt-lg-0 right-box'>
              <div className='footer-form-box contact-us-form dark-box-1 p-lg-5'>
                <LazyLoad offset={300}>
                  <ContactFormNew />
                </LazyLoad>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default RequestQuote
